import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";

const Diagnostic = () => {
  const location = useLocation();

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 진단 테스트`;

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });
  }, [location]);

  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/presence">아소비 입회</a>
              </li>
              <li>
                <a href="/diagnostic" className="sel">
                  진단 테스트
                </a>
              </li>
              <li>
                <a href="/sptp">SPTP 종합심리검사</a>
              </li>
              <li>
                <a href="/branch">우리 동네 아소비</a>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <ScrollAnimation />
      <section id="container">
        <div className="subvisual">
          <div className="title">아소비 입회</div>
          <div className="text">
            초등학교 입학 전후, 우리 아이 교육이 걱정되신다면 <br />
            지금 유기농공부 아소비로 시작해보세요!
          </div>
          <div className="image">
            <img
              src="../custom-resources/img/sub_presence_bg.png"
              alt=""
              className="pc-view"
            />
            <img
              src="../custom-resources/img/sub_presence_bg_mo.png"
              alt=""
              className="mo-view"
            />
          </div>
        </div>
        <div className="breadcrumb">
          <div className="wrap">
            <div className="loca">
              <span>
                <img src="../custom-resources/img/icon_home.png" alt="" />
              </span>
              <span className="on">아소비 입회</span>
            </div>
            <div className="menu">
              <a href="/diagnostic" className="on">
                진단 테스트
              </a>
              <a href="/sptp">SPTP 종합심리검사</a>
              <a href="/branch">우리 동네 아소비</a>
            </div>
          </div>
        </div>
        <div className="diagnostic">
          <div className="sect diagnostic01">
            <div className="wrap">
              <div className="img">
                <img
                  src="../custom-resources/img/img_diagnostic_diagnostic01_bg.png"
                  className="pc-view"
                  alt="diagnostic01_bg.png"
                />
                <img
                  src="../custom-resources/img/img_diagnostic_diagnostic01_bg_mo.png"
                  className="mo-view"
                  alt="diagnostic01_bg_mo.png"
                />
              </div>
              <div className="tit init">
                아소비만의 정확한 진단 테스트로 <br />
                아이의 첫 학습 단추를 끼워줍니다.
              </div>
              <div className="move">
                <img
                  src="../custom-resources/img/img_diagnostic_diagnostic01.gif"
                  className="pc-view"
                  alt="diagnostic01.gif"
                />
                <img
                  src="../custom-resources/img/img_diagnostic_diagnostic01_mo.gif"
                  className="mo-view"
                  alt="diagnostic01_mo.gif"
                />
              </div>
            </div>
          </div>
          <div className="sect diagnostic02">
            <div className="wrap">
              <div className="tit init">
                <img
                  src="../custom-resources/img/img_diagnostic_diagnostic02_title.png"
                  alt=""
                />
              </div>
              <div className="txt init">
                아이들의 발달에 맞추어 학습을 시작하는 데 있어서 <br />첫 교육에
                고민이 많은 학부모님과 학습의 첫 걸음에 당황해 할 우리 아이의{" "}
                <br />
                학습 상태를 정확하게 분석하여 개인별 맞춤 관리 및 전문적인 자기
                주도 학습이 가능하도록 <br />
                아소비 입회 시 학습 진단 테스트를 제공하고 있습니다.
              </div>
            </div>
          </div>
          <div className="sect diagnostic03">
            <div className="wrap">
              <div className="tit init">진단 테스트 구성</div>
              <div className="txt init">
                <dl>
                  <dt>한글</dt>
                  <dd>
                    <ul>
                      <li>
                        <div>
                          <p>
                            낱글자/이중모음 <br />
                            겹글자/받침글자 <br />
                            정확하게 읽음을 확인
                          </p>
                          <img
                            src="../custom-resources/img/img_diagnostic_diagnostic03_icon01.png"
                            alt=""
                          />
                        </div>
                        <strong>읽기 영역</strong>
                        <i></i>
                      </li>
                      <li>
                        <div>
                          <p>
                            문장을 불러주는대로 <br />
                            받아쓸 수 있는지 확인
                          </p>
                          <img
                            src="../custom-resources/img/img_diagnostic_diagnostic03_icon02.png"
                            alt=""
                          />
                        </div>
                        <strong>쓰기 영역</strong>
                        <i></i>
                      </li>
                      <li>
                        <div>
                          <p>
                            문제의 분석과 <br />
                            상황 판단을 확인
                          </p>
                          <img
                            src="../custom-resources/img/img_diagnostic_diagnostic03_icon03.png"
                            alt=""
                          />
                        </div>
                        <strong>말하기 · 듣기</strong>
                        <i></i>
                      </li>
                    </ul>
                  </dd>
                </dl>
                <dl>
                  <dt>수학</dt>
                  <dd>
                    <ul>
                      <li>
                        <div>
                          <p>
                            숫자 1~10까지 <br />
                            수와 양에 대한 <br />
                            개념을 확인
                          </p>
                          <img
                            src="../custom-resources/img/img_diagnostic_diagnostic03_icon04.png"
                            alt=""
                          />
                        </div>
                        <strong>수의 영역</strong>
                        <i></i>
                      </li>
                      <li>
                        <div>
                          <p>
                            덧셈과 뺄셈 <br />
                            연산 영역 확인
                          </p>
                          <img
                            src="../custom-resources/img/img_diagnostic_diagnostic03_icon05.png"
                            alt=""
                          />
                        </div>
                        <strong>연산 영역</strong>
                        <i></i>
                      </li>
                      <li>
                        <div>
                          <p>
                            문제를 읽고 <br />식 만들기
                          </p>
                          <img
                            src="../custom-resources/img/img_diagnostic_diagnostic03_icon06.png"
                            alt=""
                          />
                        </div>
                        <strong>서술 영역</strong>
                        <i></i>
                      </li>
                    </ul>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
          <div className="sect diagnostic04">
            <div className="wrap">
              <div className="tit init">진단 테스트 장점</div>
              <div className="txt init">
                <ol>
                  <li>
                    각 분야의 교육 전문가가 참여하고 정확한 검사 문항을 제작하여
                    서비스를 제공
                  </li>
                  <li>
                    수업 현장의 특성을 반영한 다양한 문항을 제작하고 객관적인
                    결과 제공
                  </li>
                  <li>
                    제작된 문항의 정확한 답안을 제공하고 여러 번의 진단 테스트로
                    신뢰성과 정확성이 확보된 테스트 결과 제공
                  </li>
                  <li>
                    진단 테스트 결과를 바탕으로 1:1 개인별 맞춤 관리를 통해 학습
                    방향과 진도를 제공
                  </li>
                </ol>
              </div>
            </div>
          </div>
          <div className="sect diagnostic05">
            <div className="wrap">
              <div className="tit init">
                아소비니까 가능한 우리 아이의
                <br />
                <span>정확한 진단 테스트</span>
              </div>
              <div className="img">
                <ul>
                  <li>
                    <img
                      src="../custom-resources/img/img_diagnostic_diagnostic05_img01.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      src="../custom-resources/img/img_diagnostic_diagnostic05_img02.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      src="../custom-resources/img/img_diagnostic_diagnostic05_img03.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      src="../custom-resources/img/img_diagnostic_diagnostic05_img04.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <img
                      src="../custom-resources/img/img_diagnostic_diagnostic05_img05.png"
                      alt=""
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Diagnostic;
